import React from 'react';
import { HashRouter, Route, Redirect } from "react-router-dom";
import { UserContextProvider } from './context/UserContext'
import { ViewsContextProvider } from './context/ViewsContext'
import { ConfigurationContextProvider } from './context/ConfigurationContext'
import StartView from './views/StartView';
import LoadingView from './views/LoadingView';
import ConfigView from './views/ConfigView';
import SummaryView from './views/SummaryView';
import RegisterView from './views/RegisterView';
import ConfirmationView from './views/ConfirmationView';
import './App.css';
import './style/style.css'
import './style/output.css';

function App() {
  return (
    <ConfigurationContextProvider>
      <ViewsContextProvider>
        <UserContextProvider>
          <HashRouter basename="/konfigurator">
            <Route
              exact
              path="/"
              render={() => <Redirect to="/loading" />}
            />
            <Route path="/loading" render={() => <LoadingView />} />
            <Route path="/start" render={() => <StartView />} />
            <Route path="/config" render={() => <ConfigView />} />
            <Route path="/summary" render={() => <SummaryView />} />
            <Route path="/register" render={() => <RegisterView />} />
            <Route path="/confirmation" render={() => <ConfirmationView />} />
          </HashRouter>
        </UserContextProvider>
      </ViewsContextProvider>
    </ConfigurationContextProvider>
  );
}

export default App;

/*
<Route path="/register" render={() => <RegisterView />} />
<Route path="/confirmation" render={() => <ConfirmationView />} />
*/
